import { Piece } from "./board/Piece";

import { GameConstants } from "./GameConstants";

export class GameVars {

    public static gameData: GameData;

    public static scaleY: number;
    public static firstTimeSplash: boolean;

    public static chess: Chess;
    
    public static againstAI: boolean;
    public static puzzleMoves: number;
    public static revertingMovement: boolean;
    public static time: number;
    public static moves: number;
    public static playerResigned: boolean;
    public static timeOut: boolean;
    public static isTimerOn: boolean;
    public static colorPlayer: string;
    public static selectedPiece: Piece;
    public static currentTurn: string;
    public static fen: string;
    public static fenHistory: string[];
    public static currentHistory: number;
    public static bot: boolean;
    public static difficulty: string;
    public static colorAndDifficultyUnselected: boolean;
    public static gamePaused: boolean;
    public static resigning: boolean;
    public static capturedPieces: string[];
    public static capturedPiece: Piece;
    public static gameFinished: boolean;
    public static startTime: number;
    public static stalemate: boolean;
    public static inviting: boolean;
    public static ranks: any;
    public static avatarsLoaded: boolean;
    public static usingDefaultAvatars: boolean;
    public static playerCapturedPiecesVisible: boolean;
    public static adversaryCapturedPiecesVisible: boolean;
    public static typeAd: string;
    
    public static leftBlackKnightInstantiated: boolean;
    public static leftWhiteKnightInstantiated: boolean;

    public static playingWithFriend: boolean;
    public static lastMessageID: string;
    public static globalStatsData: GlobalStatsData;

    public static playerResignedAIGame: boolean;

    public static developmentBot: Bot;

    // challenges
    public static challenge: boolean;
    public static problemsData: { [key: string]: ProblemData; };
    public static currentLevel: string;
    public static currentLevelName: string;
    public static levelMoves: number;
    public static showLevelCompleted: boolean;

    // hints
    public static hintPos: number;
    public static useBotHint: boolean;

    public static onAd: boolean;

    public static language: string;
    public static texts: string;

    public static getBoardPosition(p: string): string {

        let i = -1;

        for (let j = 0, ln = GameConstants.ROWS.length; j < ln; j++) {

            i = p.indexOf(GameConstants.ROWS[j]);

            if (i >= 0) {
                break;
            }
        }

        if (i > 0) {

            return p.substr(i - 1, 2);

        } else {

            // ver si se trata de un enroque 
            if (p === GameConstants.CASTLING_QUEEN) {
                if (GameVars.currentTurn === GameConstants.WHITE) {
                    return "c1";
                } else {
                    return "c8";
                }
            } else if (p === GameConstants.CASTLING_KING) {
                if (GameVars.currentTurn === GameConstants.WHITE) {
                    return "g1";
                } else {
                    return "g8";
                }
            } else {
                return null;
            }
        }
    }

    public static getPieceInfo(pieceType: string): {textureName: string, color: string} {

        let textureName: string;
        let color: string;

        switch (pieceType) {

            case GameConstants.WHITE_BISHOP:
                textureName = "white_bishop.png";
                color = GameConstants.WHITE;
                break;

            case GameConstants.WHITE_KING:
                textureName = "white_king.png";
                color = GameConstants.WHITE;
                break;

            case GameConstants.WHITE_KNIGHT:

                if (!GameVars.leftWhiteKnightInstantiated) {
                    GameVars.leftWhiteKnightInstantiated = true;
                    textureName = "white_knight_left.png";
                } else {
                    textureName = "white_knight_right.png";
                }

                color = GameConstants.WHITE;
                break;

            case GameConstants.WHITE_PAWN:
                textureName = "white_pawn.png";
                color = GameConstants.WHITE;
                break;

            case GameConstants.WHITE_QUEEN:
                textureName  = "white_queen.png";
                color = GameConstants.WHITE;
                break;

            case GameConstants.WHITE_ROOK:
                textureName = "white_rook.png";
                color = GameConstants.WHITE;
                break;

            case GameConstants.BLACK_BISHOP:
                textureName = "black_bishop.png";
                color = GameConstants.BLACK;
                break;

            case GameConstants.BLACK_KING:
                textureName = "black_king.png";
                color = GameConstants.BLACK;
                break;

            case GameConstants.BLACK_KNIGHT:

                if (!GameVars.leftBlackKnightInstantiated) {
                    GameVars.leftBlackKnightInstantiated = true;
                    textureName = "black_knight_left.png";
                } else {
                    textureName = "black_knight_right.png";
                }

                color = GameConstants.BLACK;
                break;

            case GameConstants.BLACK_PAWN:
                textureName = "black_pawn.png";
                color = GameConstants.BLACK;
                break;

            case GameConstants.BLACK_QUEEN:
                textureName = "black_queen.png";
                color = GameConstants.BLACK;
                break;

            case GameConstants.BLACK_ROOK:
                textureName = "black_rook.png";
                color = GameConstants.BLACK;
                break;

            default:
                break;
        }

        return {textureName: textureName, color: color};
    }

    public static getCoordinatesFromPosition(p: string): {x: number, y: number} {

        const col = p[0];
        const row = p[1];

        const c = GameConstants.COLUMNS.indexOf(col);
        const r = GameConstants.ROWS.indexOf(row);

        const x = (c - 3.5) * GameConstants.SQUARE_WIDTH;
        const y = (r - 3.5) * GameConstants.SQUARE_WIDTH;

        return {x: x, y: y};
    }

    public static formatTime(timeInSeconds: number, endLayer?: boolean): string {

        if (isNaN(timeInSeconds) || timeInSeconds > 24 * 3600) {
            if (endLayer) {
                return "0s";
            } else {
                return "0:00:00";
            }
        }

        const hours   = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds - (hours * 3600)) / 60);
        const seconds = timeInSeconds - (hours * 3600) - (minutes * 60);

        let h = hours.toString();
        let m = minutes.toString();
        let s = seconds.toString();

        if (hours < 10) {
            h = "0" + hours;
        }

        if (minutes < 10) { 
            m = "0" + minutes;
        }

        if (seconds < 10) {
            s = "0" + seconds;
        }

        if (endLayer) {

            let timeStr = s + "s";

            if (minutes > 0) {
                timeStr = m + "m" + timeStr;
            }

            if (hours > 0) {
                timeStr = h + "h" + timeStr;
            }

            return timeStr;
            
        } else {
            return h + ":" + m + ":" + s;
        }
    }

    public static getMoves(): number {

        if (GameVars.fen === GameConstants.FEN_START) {
            return 0;
        } else {
                let j: number;

            // buscar el ultimo espacio del string y pillar todo desde alli
            for (let i = GameVars.fen.length - 1; i >= 0; i--) {
                if (GameVars.fen[i] === " ") {
                    j = i;
                    break;
                }
            }

            let m: string = "";

            for (let i = j + 1; i < GameVars.fen.length; i++) {
                m += GameVars.fen[i];
            }

            return parseInt(m);
        }
    }

    public static validName(name: string): string {
        
        let i = name.indexOf(" ");

        if (i >= 0) {
            name = name.substr(0, i);
        }

        if (name.length > 13) {
            name = name.substr(0, 11);
            name += "...";
        }

        return name;
    }

    public static getCurrentTurn(): string {

        let fen = GameVars.chess.fen();

        let tmpArray: string[] = fen.split("/");
        tmpArray = tmpArray[7].split(" ");

        return tmpArray[1];
    }
}
